import { ovationApi } from 'config'
import { generatePath } from 'react-router-dom'
import { CustomerResponse, CustomerSearchParams, CustomersListResponse } from './models/customer'

import client from '../chowly'
const generateParams = (conversationBody: CustomerSearchParams) => {
  const params = new URLSearchParams()
  Object.entries(conversationBody).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, v))
    } else {
      params.append(key, value)
    }
  })
  return params
}

export const listCustomers = async (searchParams: CustomerSearchParams) => {
  const url = generatePath(ovationApi.customerList)

  const { data } = await client.get<CustomersListResponse>(url + '?' + generateParams(searchParams))
  return data
}

export const getCustomer = async (customerId: string, partnerId: string) => {
  const url = generatePath(ovationApi.customer, {customer_id: customerId})

  const { data } = await client.get<CustomerResponse>(url + '?partner_id=' + partnerId)
  return data
}